module.exports = "/images/vendor/vue-paycard/src/laser.png?c4d16ad73d5c0906e33f40729a1f2d1a";